module.exports = __webpack_public_path__ + "static/media/logo.157561ea.webp";